export default __webpack_public_path__ + "static/media/Defect_count.02239286.svg";